export const COUNTRIES_WITHOUT_USERCENTRICS: Array<number> = [];

export const USERCENTRICS_CONFIGURATION = {
  settingsId: 'Zq9yzvGAs',
  paths: {
    bundle: 'https://app.usercentrics.eu/browser-ui/latest/loader.js',
  },
};
